(function(){
  var popup=document.getElementById('ha-1010-popup');
  if(!popup)return;
  var starts=new Date('2026-10-10T18:00:00+01:00').getTime();
  var ends=new Date('2026-10-12T18:00:00+01:00').getTime();
  var now=Date.now(),seen=false;
  try{seen=sessionStorage.getItem('ha1010PopupSeenThisVisit')==='1';}catch(e){}
  if(now>=ends||seen){popup.remove();return;}
  var displayed=false,previousFocus=null;
  function close(){if(previousFocus&&previousFocus.focus)previousFocus.focus();popup.remove();}
  function show(){
    if(displayed)return;
    if(Date.now()>=ends){close();return;}
    displayed=true;previousFocus=document.activeElement;
    if(!popup||!popup.isConnected)return;
    var note=popup.querySelector('small');
    if(Date.now()<starts&&note){note.textContent='Available from 6PM UK today · Ends 12.10.26 at 6PM UK. Discount minimum: £150. Free UK standard delivery requires £150 after discounts. Delivery and preparation times still apply.';}
    try{sessionStorage.setItem('ha1010PopupSeenThisVisit','1');}catch(e){}
    popup.hidden=false;popup.setAttribute('aria-hidden','false');popup.querySelector('[data-ha-popup-close].ha-1010-popup__close').focus();
  }
  function waitForIntro(){
    var intro=document.getElementById('ha-intro');
    if(!intro){setTimeout(show,120);return;}
    if(intro.hidden||intro.getAttribute('aria-hidden')==='true'){setTimeout(show,180);return;}
    window.addEventListener('ha:intro-complete',function(){setTimeout(show,180);},{once:true});
    setTimeout(show,7000);
  }
  waitForIntro();
  setTimeout(close,Math.max(0,ends-Date.now()));
  popup.querySelectorAll('[data-ha-popup-close]').forEach(function(el){el.addEventListener('click',close);});
  var copy=document.getElementById('ha-copy-1010');
  if(copy)copy.addEventListener('click',function(){
    var done=function(){copy.textContent='COPIED';setTimeout(function(){copy.textContent='COPY';},1600);};
    var failed=function(){copy.textContent='SELECT CODE';setTimeout(function(){copy.textContent='COPY';},1600);};
    if(navigator.clipboard&&navigator.clipboard.writeText){navigator.clipboard.writeText('ADDICTION10').then(done).catch(failed);}else{failed();}
  });
  document.addEventListener('keydown',function(e){if(!popup||!popup.isConnected||popup.hidden)return;if(e.key==='Escape'){close();return;}if(e.key==='Tab'){var items=Array.from(popup.querySelectorAll('button,a[href]')),first=items[0],last=items[items.length-1];if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus();}else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();}}});
})();